import React from 'react';
import {TextArea, Label} from 'components';
import i18n from 'i18next';

type TextFormProps = {
  value?: string;
  setValue: (newValue: string) => void;
  disabled?: boolean;
};

function TextForm({value, setValue, disabled}: TextFormProps) {
  return (
    <Label
      htmlFor="text-form"
      label={i18n.t('wisbitPage.addComponentModal.textForm.titleLabel')}
    >
      <TextArea
        id="text-form"
        value={value}
        onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) =>
          setValue(event.target.value)
        }
        className="h-44"
        disabled={disabled}
      />
    </Label>
  );
}

export default TextForm;
